import React, { useState, useEffect } from "react";
import { Nav, Button, Tag } from "@douyinfe/semi-ui";
import { ReactComponent as GlobalIcon } from "@assets/icons/global_icon.svg";
import { ReactComponent as LogoIcon } from "@assets/icons/logo.svg";
import { useNavigate, useLocation } from "react-router-dom";
import { removeLocalStorage } from "@utils/localstorage";
import { LoginEnum } from "@services/account/enum/login.enum";
import { RootState, AppDispatch } from "@state/store";
import { useSelector, useDispatch } from "react-redux";
import { removeToken } from "@state/global/reducer";
import { MENUS } from "@config/menus";
import { useTranslation } from "react-i18next";
import styles from "./index.module.scss";

const NavHeader = () => {
  const { t, i18n } = useTranslation();

  const location = useLocation();
  const dispatch = useDispatch<AppDispatch>();

  const token = useSelector((state: RootState) => state.global.token);

  const [selectedKeys, setSelectedKeys] = useState<React.ReactText[]>([]);
  const navigate = useNavigate();

  function onLogout() {
    removeLocalStorage(LoginEnum.Token);
    dispatch(removeToken());
    navigate("/about");
  }

  function toHome() {
    navigate("/home");
  }

  function clickMenu(item: {
    itemKey?: React.ReactText | undefined;
    domEvent?: MouseEvent | undefined;
    isOpen?: boolean | undefined;
  }) {
    if (!item.itemKey) {
      return;
    }

    if (item.itemKey === "about") {
      setSelectedKeys([item.itemKey]);
      navigate(`/${item.itemKey}`);
    } else {
      if (token) {
        setSelectedKeys([item.itemKey]);
        navigate(`/${item.itemKey}`);
      } else {
        const path = `/${item.itemKey}`;
        navigate(`/about?login=true&redirect=${encodeURIComponent(path)}`);
      }
    }
  }

  function toMainPage() {
    navigate("/promotion");
  }

  function onReport(path: string) {
    window.open(path, "_blank");
  }

  const changeLanguage = (lang: "en" | "zh") => {
    i18n.changeLanguage(lang);
  };

  function onSelectChange(value: string) {
    if (value === "en" || value === "zh") {
      changeLanguage(value);
    }
  }

  useEffect(() => {
    const pathname = location.pathname;

    const target = MENUS.find((item) => {
      return pathname.includes(`${item.itemKey!}`);
    });

    if (target) {
      setSelectedKeys([`${target.itemKey!}`]);
    } else {
      setSelectedKeys([]);
    }
  }, [location.pathname]);

  return (
    <Nav
      selectedKeys={selectedKeys}
      onClick={clickMenu}
      mode={"horizontal"}
      className={styles.container}
      // items={MENUS}
      header={{
        logo: <LogoIcon onClick={toHome} style={{ cursor: "pointer" }} />,
        text: (
          <span onClick={toHome} style={{ cursor: "pointer" }}>
            BioGeometry
          </span>
        ),
      }}
      footer={
        <div className="semi-navigation-list">
          <Button
            className="main-btn"
            onClick={toMainPage}
            style={{ marginRight: 36 }}
          >
            {t("header.tryText")}
          </Button>
          <Nav.Item
            link="https://www.biogeom.com"
            linkOptions={{
              target: "_blank",
              title: "About us",
            }}
            style={{ fontSize: "17px", fontWeight: 400 }}
            text={t("header.about")}
          />
          <Nav.Sub itemKey={"report"} text={t("header.report")}>
            <Nav.Item
              itemKey={"v3"}
              text={
                <span>
                  GeoFlow V3 <Tag className={styles.tag}>New</Tag>
                </span>
              }
              onClick={() => onReport("/report")}
            />
            <Nav.Item
              itemKey={"v2"}
              text="GeoFlow V2"
              onClick={() => onReport("/report-v2")}
            />
          </Nav.Sub>
          <Nav.Item
            itemKey="gallery"
            style={{ fontSize: "17px", fontWeight: 400 }}
            text={t("header.gallery")}
          />

          <Button
            theme="borderless"
            type="tertiary"
            icon={<GlobalIcon />}
            style={{
              fontWeight: 400,
              fontSize: "16px",
            }}
            onClick={() =>
              onSelectChange(i18n.resolvedLanguage === "en" ? "zh" : "en")
            }
          >
            {i18n.resolvedLanguage === "en" ? "中文" : "English"}
          </Button>
        </div>
      }
    />
  );
};

export default NavHeader;
